var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./RatesListingsPopup.jinja');
require('./RatesListingsPopup.less');

var CommonRegions = require('front/components/CommonRegions/CommonRegions');
var ProductionListings = require('front/components/ProductionListings/ProductionListings');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({
    }, BasePopup.prototype.baseEvents),

    VIEWS_TO_REGISTER: {
        'CommonRegions': {selector: '.CommonRegions', viewConstructor: CommonRegions},
        'ProductionListings': {selector: '.ProductionListings', viewConstructor: ProductionListings}
    },

    apiUrl: function () {
        return Urls['front:api:rates_listings-popup'](this.region);
    },


    initialize: function (options) {
        this.options = options || {};

        this.region = this.options.region;

        BasePopup.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        BasePopup.prototype.viewsRegistration.call(this);

        var pdf = this.$('.RatesListingsPopup').attr('data-pdf');

        if (pdf) {
            this.$('.BasePopup-download')
                .show()
                .attr('href', pdf);
        }
    },


    onPrintClick: function () {
        if (this.disablePrint) return;

        var printContent = this.$('.RatesListingsPopup-listing')[0];
        var headContent = $('head')[0];
        var windowUrl = 'about:blank';
        var uniqueName = new Date();
        var windowName = 'Print ' + this.$('.RatesListingsPopup-caption').text();

        var printWindow = window.open(windowUrl, windowName, 'left=0,top=0,width=1024,height=600');

        printWindow.document.write(headContent.innerHTML);
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.documentElement.style.fontSize = '400px';
        printWindow.document.close();
        printWindow.focus();

        this.disablePrint = true;

        setTimeout(function () {
            printWindow.print();
            printWindow.close();
            delete this.disablePrint;
        }.bind(this), 1500);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/RatesListingsPopup/RatesListingsPopup.js
// module id = 293
// module chunks = 0